module.exports = __webpack_public_path__ + "static/media/Speaker.7830747d.svg";